import { useKeycloak } from '@react-keycloak/web'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import Navigation from '@/navigation/Navigation'

import { SnackbarProvider } from './components/ui/snackbar/SnackbarProvider'
import Spinner from './components/ui/spinner/Spinner'
import { ToastProvider } from './components/ui/toast/ToastProvider'
import { TagsPrefetcher } from './features/FormUploader/components/TagsPrefetcher'

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false
		}
	}
})

function App() {
	const { initialized } = useKeycloak()

	if (!initialized) {
		return <Spinner />
	}

	return (
		<QueryClientProvider client={queryClient}>
			<TagsPrefetcher />
			<BrowserRouter>
				<SnackbarProvider>
					<Navigation />
					<ToastProvider />
				</SnackbarProvider>
			</BrowserRouter>
		</QueryClientProvider>
	)
}

export default App
